export default [
  {
    path: '/admin/borrowing-spare-part-claims',
    name: 'borrowing-spare-part-claim',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/borrowing-spare-part-claim/index.vue')
  },

]
